export interface ScrollBounds {
    top: number;
    bottom: number;
}

/** Luft, damit die Zeile nicht direkt an der Kante klebt. */
export const COLUMN_SCROLL_MARGIN = 16;

/**
 * Um wie viel muss `container.scrollTop` verändert werden, damit `row` sichtbar ist?
 *
 * 0 = bereits vollständig sichtbar, nicht scrollen — das ist der Normalfall beim
 * Anklicken einer Zeile. Vorher wurde die Auswahl immer zentriert, was bei jeder
 * Selektion einen sichtbaren Sprung in langen Spalten (Companies) erzeugte.
 *
 * Beide Bounds sind viewport-relativ (`getBoundingClientRect`), das Ergebnis ist
 * ein Delta auf `scrollTop` (negativ = nach oben scrollen).
 */
export const getColumnScrollDelta = (
    view: ScrollBounds,
    row: ScrollBounds,
    margin: number = COLUMN_SCROLL_MARGIN
): number => {
    if (row.top >= view.top && row.bottom <= view.bottom) return 0;
    // Oben-Zweig zuerst: eine Zeile, die höher ist als der Viewport, wird dadurch
    // oben ausgerichtet statt unten.
    return row.top < view.top
        ? row.top - view.top - margin
        : row.bottom - view.bottom + margin;
};

/**
 * Scrollt `row` innerhalb von `scroller` sichtbar (Delta wie oben). Rechnet mit
 * `offsetTop` statt `getBoundingClientRect`, weil Rects während einer
 * Scale-Transition (Öffnen des MUI-Menüs, „Grow“) verzerrt sind. `scroller` muss
 * in der offsetParent-Kette der Zeile liegen, also positioniert sein — sonst wird
 * nicht gescrollt.
 */
export const revealRowInScroller = (scroller: HTMLElement, row: HTMLElement): void => {
    let top = 0;
    let el: HTMLElement | null = row;
    while (el && el !== scroller) {
        top += el.offsetTop;
        el = el.offsetParent as HTMLElement | null;
    }
    if (el !== scroller) return;
    const delta = getColumnScrollDelta(
        { top: scroller.scrollTop, bottom: scroller.scrollTop + scroller.clientHeight },
        { top, bottom: top + row.offsetHeight }
    );
    if (delta !== 0) scroller.scrollTop += delta;
};
